import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    FaBoxes,
    FaTachometerAlt,
    FaStore,
    FaUsers,
    FaTruck,
    FaUserFriends,
    FaBoxOpen,
    FaCashRegister,
    FaClipboardList,
    FaSignOutAlt
} from "react-icons/fa";

const Layout = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(null);

    const admin = JSON.parse(localStorage.getItem("admin"));

    const logout = () => {
        localStorage.clear();
        navigate("/");
    };

    return (
        <div className="dashboard">

            {/* SIDEBAR */}
            <div className="sidebar">
                <h2>POS SYSTEM</h2>

                <ul>
                    <li className={location.pathname === "/dashboard" ? "active" : ""}
                        onClick={() => navigate("/dashboard")}>
                        <FaTachometerAlt className="menu-icon" />
                        Dashboard
                    </li>

                    <li className={location.pathname === "/stores" ? "active" : ""}
                        onClick={() => navigate("/stores")}>
                        <FaStore className="menu-icon" />
                        Stores
                    </li>
                    <li
                        className={location.pathname === "/users" ? "active" : ""}
                        onClick={() => navigate("/users")}
                    >
                        <FaUsers className="menu-icon" />
                        Enquiry List
                    </li>
                    <li className={location.pathname === "/stock" ? "active" : ""}
                        onClick={() => navigate("/stock")}>
                        <FaBoxes className="menu-icon" />
                        Stock Management
                    </li>

                    <li onClick={() => setOpenMenu(openMenu === "suppliers" ? null : "suppliers")}>
                        <FaTruck className="menu-icon" />
                        Suppliers {openMenu === "suppliers" ? "▲" : "▼"}
                    </li>

                    {openMenu === "suppliers" && (
                        <ul className="submenu">
                            <li
                                className={location.pathname === "/suppliers" ? "active" : ""}
                                onClick={() => navigate("/suppliers")}
                            >
                                Supplier List
                            </li>

                            <li
                                className={location.pathname === "/supplier-returns" ? "active" : ""}
                                onClick={() => navigate("/supplier-returns")}
                            >
                                Return Items
                            </li>
                        </ul>
                    )}

                    <li
                        className={location.pathname === "/customers" ? "active" : ""}
                        onClick={() => navigate("/customers")}
                    >
                        <FaUserFriends className="menu-icon" />
                        Customers
                    </li>

                    <li className={location.pathname === "/products" ? "active" : ""}
                        onClick={() => navigate("/products")}>
                        <FaBoxOpen className="menu-icon" />
                        Products
                    </li>

                    <li className={location.pathname === "/pos" ? "active" : ""} onClick={() => navigate("/pos")}><FaCashRegister className="menu-icon" />POS</li>

                    {/* ORDERS DROPDOWN */}
                    <li onClick={() => setOpenMenu(openMenu === "orders" ? null : "orders")}>
                        <FaClipboardList className="menu-icon" />
                        Orders {openMenu === "orders" ? "▲" : "▼"}
                    </li>

                    {openMenu === "orders" && (
                        <ul className="submenu">
                            <li
                                className={location.pathname === "/orders" ? "active" : ""}
                                onClick={() => navigate("/orders")}
                            >
                                Customer Orders List
                            </li>
                        </ul>
                    )}

                    <li className="logout" onClick={logout}><FaSignOutAlt className="menu-icon" />Logout</li>
                </ul>
            </div>

            {/* MAIN */}
            <div className="main">

                <div className="topbar">
                    <h3>POS System</h3>
                    <div>{admin?.name}</div>
                </div>

                {children}

            </div>
        </div>
    );
};

export default Layout;